export default __webpack_public_path__ + "static/media/QuiddLoader.b928e037.gif";